import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';

export type BackendDeps = { fetchApi: FetchApi; discoveryApi: DiscoveryApi };

/**
 * Calls a backend plugin: resolves its base URL with `discoveryApi`, sends the
 * request through `fetchApi` (authenticated) and throws `ResponseError` on a
 * non-OK response. Only glue over those three; `init` is passed through
 * untouched and `path` is used as given (leading `/` and encoding are the
 * caller's job).
 */
export async function backendRequest<T>(
  pluginId: string,
  path: string,
  { fetchApi, discoveryApi }: BackendDeps,
  init?: RequestInit,
): Promise<T> {
  const base = await discoveryApi.getBaseUrl(pluginId);
  const res = await fetchApi.fetch(`${base}${path}`, init);
  if (!res.ok) {
    throw await ResponseError.fromResponse(res);
  }
  if (res.status === 204) {
    return undefined as T;
  }
  return (await res.json()) as T;
}
